var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2P({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "p2p",
    transform: "translate(299 -8211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify_acc",
    transform: "translate(-219 83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-80 8128)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e5624d39b35c645fcb2dc242597966b6",
    transform: "translate(-77.942 8130.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 60,
    height: 60,
    rx: 5.917,
    transform: "translate(-0.058 -0.058)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_6ff7059651c450389c806a45405832f6",
    "data-name": "6ff7059651c450389c806a45405832f6",
    transform: "translate(9.16 9.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24651",
    "data-name": "Path 24651",
    d: "M20.782,1021.86A19.282,19.282,0,1,1,1.5,1041.142",
    transform: "translate(0 -1020.363)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 1.5,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24652",
    "data-name": "Path 24652",
    d: "M34.518,1032.172a16.622,16.622,0,1,1-10.093-7.745",
    transform: "translate(0.659 -1019.704)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 1.5,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24653",
    "data-name": "Path 24653",
    d: "M19,1025.86A13.963,13.963,0,1,1,6.907,1046.8",
    transform: "translate(1.783 -1019.044)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 1.5,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24654",
    "data-name": "Path 24654",
    d: "M18.8,1050.466a11.3,11.3,0,1,1,11.3-11.3",
    transform: "translate(1.979 -1018.384)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 1.5,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24655",
    "data-name": "Path 24655",
    d: "M14.573,11a1.022,1.022,0,0,0-.875.5,3.242,3.242,0,0,0-.4,1,5.192,5.192,0,0,1-.656,1.853l-.184.184.23.149a5.325,5.325,0,0,0,1.323.587c.1.035.115.092.127.185a1.293,1.293,0,0,1-.38.863,5.443,5.443,0,0,1-.909.714,5.976,5.976,0,0,0-.99.759,1.544,1.544,0,0,0-.494,1.094V19.1h7.514v-.219a1.569,1.569,0,0,0-.494-1.083,7.26,7.26,0,0,0-.979-.771,5.555,5.555,0,0,1-.92-.714,1.228,1.228,0,0,1-.369-.852c0-.138.058-.184.1-.207A4.527,4.527,0,0,0,17.5,14.67l.219-.138-.185-.184a5.654,5.654,0,0,1-.725-1.876,3.072,3.072,0,0,0-.46-1A1.154,1.154,0,0,0,15.4,11h-.828Z",
    transform: "translate(2.84 2.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24656",
    "data-name": "Path 24656",
    d: "M14.573,11a1.022,1.022,0,0,0-.875.5,3.242,3.242,0,0,0-.4,1,5.192,5.192,0,0,1-.656,1.853l-.184.184.23.149a5.325,5.325,0,0,0,1.323.587c.1.035.115.092.127.185a1.293,1.293,0,0,1-.38.863,5.443,5.443,0,0,1-.909.714,5.976,5.976,0,0,0-.99.759,1.544,1.544,0,0,0-.494,1.094V19.1h7.514v-.219a1.569,1.569,0,0,0-.494-1.083,7.26,7.26,0,0,0-.979-.771,5.555,5.555,0,0,1-.92-.714,1.228,1.228,0,0,1-.369-.852c0-.138.058-.184.1-.207A4.527,4.527,0,0,0,17.5,14.67l.219-.138-.185-.184a5.654,5.654,0,0,1-.725-1.876,3.072,3.072,0,0,0-.46-1A1.154,1.154,0,0,0,15.4,11h-.828Z",
    transform: "translate(10.84 9.134)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2P);
export default __webpack_public_path__ + "static/media/p2p.72e9ee92f8de60ef9fc56de848a7d8fc.svg";
export { ForwardRef as ReactComponent };